/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../../assets/logo.png";
import logo2 from "../../assets/logo2.png";
import "./Navigation.css";

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const navLinks = [
    { id: "home", label: "HOME", path:"/" },
    { id: "about", label: "ABOUT", path: "/about" },
    { id: "services", label: "SERVICES", path: "/#services" },
   { id: "works", label: "WORKS", path: "/works" }, 
    { id: "team", label: "CLIENTS", path: "/team" },
    { id: "connect", label: "CONNECT", path: "/contact" }
  ];

  useEffect(() => {
    setIsMenuOpen(false); // Close menu on navigation
    document.body.style.overflow = "auto"; // Reset body overflow to allow scrolling
    
    // Check if we have a hash in the URL to scroll to
    if (location.hash) {
      setTimeout(() => {
        const id = location.hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  }, [location.pathname, location.hash]);

  const toggleMenu = () => {
    const newState = !isMenuOpen;
    setIsMenuOpen(newState);
    // Prevent scrolling when menu is open
    document.body.style.overflow = newState ? "hidden" : "auto";
  };

  const handleNavClick = (link) => {
    // Always close menu and reset overflow before any action
    setIsMenuOpen(false);
    document.body.style.overflow = "auto";

    if (link.path.startsWith("/#")) {
      const id = link.path.replace("/#", "");
      if (location.pathname === "/") {
        // Already on home, just scroll
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        // Navigate to home with hash
        navigate(link.path);
      }
    } else {
      // If already on the page, scroll to top
      if (location.pathname === link.path) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        navigate(link.path);
      }
    }
  };

  const isLightPage = ["/contact", "/team", "/"].includes(location.pathname) || location.pathname.startsWith("/works");
  const currentLogo = isLightPage && !isMenuOpen ? logo2 : logo;

  return (
    <>
      <nav className={`yo-navbar ${isMenuOpen ? "menu-open" : ""}`}>
        <Container fluid className="yo-nav-container">
          <div className="yo-logo" onClick={() => navigate("/")}>
            <img src={currentLogo} alt="Logo" />
          </div>
        </Container>
      </nav>

      <div className={`yo-menu-trigger ${isMenuOpen ? "hidden" : ""}`} onClick={toggleMenu}>
        <div className="hamburger-icon">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div className={`yo-menu-overlay ${isMenuOpen ? "active" : ""}`}>
        <div className="yo-menu-header">
          <div className="overlay-logo" onClick={() => navigate("/")}>
            <img src={logo} alt="Logo" />
          </div>
          <button className="yo-menu-close" onClick={toggleMenu}>
            <span className="close-icon">&times;</span>
          </button>
        </div>

        <div className="overlay-content">
          <div className="nav-links-wrapper">
            {navLinks.map((link, index) => (
              <div
                key={link.id}
                className="nav-item-group"
                onClick={() => handleNavClick(link)}
                style={{ transitionDelay: `${0.1 + index * 0.15}s` }}
              >
                <div className="nav-item-inner">
                  <h2 className="nav-link-text">{link.label}</h2>
                </div>
              </div>
            ))}
          </div>

          <div className="overlay-footer">
            <div className="social-links">
              <a href="#"><i className="fab fa-facebook-f"></i></a>
              <a href="#"><i className="fab fa-instagram"></i></a>
              <a href="#"><i className="fab fa-linkedin-in"></i></a>
              <a href="#"><i className="fab fa-vimeo-v"></i></a>
              <a href="#"><i className="fab fa-tiktok"></i></a>
            </div>
            <p className="footer-info">7540001028/admin@ascentbw.com</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navigation;